import React, { useEffect, useState } from 'react';
import AdminLogin from '../components/admin/AdminLogin';
import AdminDashboard from '../components/admin/AdminDashboard';
import { adminMe } from '../lib/adminApi';

export default function AdminPanel() {
  const [user, setUser] = useState(null); // null=checking, {username}=in, false=out

  useEffect(() => {
    adminMe().then((data) => setUser(data || false));
  }, []);

  if (user === null) {
    return <div className="min-h-screen bg-[#0b0d10]" />;
  }

  if (!user) {
    return <AdminLogin onLoggedIn={setUser} />;
  }

  return <AdminDashboard username={user.username} onLoggedOut={() => setUser(false)} />;
}
